import { __awaiter, __generator } from "tslib";
import { showConfirmationDialog, } from '@office-start/confirmation-dialog-component';
import { useLocStrings } from '@office-start/loc-service';
import { useCallback } from 'react';
export var useDeleteCustomPivot = function () {
    var locStrings = useLocStrings().data;
    var deleteCustomPivot = useCallback(function (onDelete) { return __awaiter(void 0, void 0, void 0, function () {
        var confirmationDialog;
        var _a, _b;
        return __generator(this, function (_c) {
            confirmationDialog = {
                confirmationText: ((_a = locStrings === null || locStrings === void 0 ? void 0 : locStrings.edgeworthResources) === null || _a === void 0 ? void 0 : _a.deleteCustomPivotConfirmationText) || '',
                affirmationButtonTitle: ((_b = locStrings === null || locStrings === void 0 ? void 0 : locStrings.edgeworthResources) === null || _b === void 0 ? void 0 : _b.deleteCustomPivotAffirmationTitle) || '',
                action: function () { return onDelete(); },
            };
            showConfirmationDialog(confirmationDialog);
            return [2 /*return*/];
        });
    }); }, [locStrings]);
    return deleteCustomPivot;
};
//# sourceMappingURL=useDeleteCustomPivot.js.map